import { Monitor, Smartphone } from "lucide-react";
import { useViewMode } from "@/hooks/useViewMode";
import { cn } from "@/lib/utils";

export default function DevModeToggle() {
  // Hooks MUST come before any conditional return (Rules of Hooks).
  // useViewMode is cheap; the env-check below disables the UI.
  const { viewMode, setOverride, override } = useViewMode();
  if (!import.meta.env.DEV) return null;

  return (
    <div className="fixed bottom-20 right-4 z-[60] flex gap-1 rounded-lg border bg-card p-1 shadow-lg">
      <button
        onClick={() => setOverride(override === "desktop" ? null : "desktop")}
        className={cn(
          "rounded-md p-2 transition-colors",
          viewMode === "desktop" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
        )}
        title="Desktop-vy"
      >
        <Monitor className="h-4 w-4" />
      </button>
      <button
        onClick={() => setOverride(override === "mobile" ? null : "mobile")}
        className={cn(
          "rounded-md p-2 transition-colors",
          viewMode === "mobile" ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
        )}
        title="Mobil-vy"
      >
        <Smartphone className="h-4 w-4" />
      </button>
    </div>
  );
}
